// @flow
import React, { Component } from "react";
import { Route } from "react-router-dom";

type PropsType = {
  component: Object,
  path: string,
  exact?: boolean
};
type StateType = {};

class PublicRoute extends Component<PropsType, StateType> {
  render() {
    const { component, ...rest } = this.props;
    return (
      <div>
        <Route {...rest} component={component} />
      </div>
    );
  }
}

export default PublicRoute;



// WEBPACK FOOTER //
// ./src/Routes/RouteWrappers/PublicRoute.js